// import * as React from "react";
// import { SvgIconProps } from "@material-ui/core";
// import { ReactComponent as TimelineBarIconSvg } from "./timelinebar_icon.svg";

// type Props = SvgIconProps;

// function TimelineBarIcon(props: Props) {
//   return <TimelineBarIconSvg {...props} />;
// }

// export default TimelineBarIcon;

import * as React from "react";
import { makeStyles, SvgIcon, SvgIconProps, Theme } from "@material-ui/core";

type Props = { barText: string } & SvgIconProps & { fillColor: string } & {
    textColor: string;
  } & styleProps;

type styleProps = {
  width?: React.CSSProperties["width"];
  height?: React.CSSProperties["height"];
};

const useStyles = makeStyles<Theme, styleProps>((theme: Theme) => ({
  iconRoot: ({ width, height }) => ({
    "& .ovewritten": { width: width || "160px", height: height || "50px" },
  }),
}));

// fill: currentColor;
//     /* width: 1em; */
//     /* height: 1em;

function TimelineBarIcon({
  barText = "",
  fillColor = "",
  textColor = "",
  width,
  height,
  ...props
}: Props) {
  const c = useStyles({ width, height });

  const loadableMessage = (message: string) => {
    return message !== "Isenção Automática da Cobrança" ? (
      <>
        <tspan x="143" y="41" text-anchor="middle">
          {message}
        </tspan>
      </>
    ) : (
      <>
        <tspan x="143" y="33" text-anchor="middle">
          {"Isenção Automática"}
        </tspan>
        <tspan x="143" y="53" text-anchor="middle">
          {"da Cobrança"}
        </tspan>
      </>
    );
  };

  return (
    <div className={c.iconRoot} style={{ height: "50px" }}>
      <SvgIcon
        className="ovewritten"
        viewBox="0 0 272 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M246.137 71L271 34.2374L246.137 1H1L25.8627 34.2374L1 71H246.137Z"
          fill={fillColor}
        />
        <text fontFamily="Roboto" fontSize="19" fill={textColor}>
          {loadableMessage(barText)}
        </text>
      </SvgIcon>
    </div>
  );
}

export default TimelineBarIcon;
